/*
 *  -----------------------------------------------------------------------
 *    <copyright file="terms-conditions.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { Typography } from '@mui/material';
import React from 'react';

const TermsConditions = () => (
    <div>
        <Typography variant="h1">OPRA e4.4 Disclaimer</Typography>
        <Typography variant="body1">
            This system is for the use of those authorized by Triumph Research Intelligence; others who access the
            system may be subject to criminal prosecution. Authorized use is governed by institutional policy and by
            state and federal laws, and each user is responsible for familiarity and compliance with their provisions.
            Usage may also be subject to monitoring and testing.
        </Typography>
    </div>
);

export default TermsConditions;
